var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path, _rect, _path2, _path3, _polygon10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.53 37.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #221f20;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.14 8.95 11.98 8.95 11.98 25.22 14.14 27.37 14.14 8.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.77 28.77 11.98 28.77 13.94 28.77 14.14 28.77 14.14 28.76 11.98 26.62 10.77 26.62 10.77 0 8.62 0 8.62 28.77 8.81 28.77 10.77 28.77"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.45 30.9 18.45 12.85 16.29 12.85 16.29 29.51 18.45 31.65 18.45 30.9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.29 33.05 18.45 33.05 16.28 30.9 6.46 30.9 6.46 4.28 4.31 4.28 4.31 30.9 4.31 33.05 6.46 33.05 16.29 33.05"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.15 35.17 2.15 8.55 0 8.55 0 35.17 0 37.33 2.15 37.33 20.6 37.33 20.6 37.34 22.75 37.34 20.58 35.17 2.15 35.17"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.6 33.8 22.75 35.94 22.75 35.17 22.75 17.17 20.6 17.17 20.6 33.8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.88 26.22 38.4 26.22 38.4 26.21 37.31 25.12 33.69 25.12 36.83 18.94 40.48 26.23 41.71 26.23 36.84 16.49 31.88 26.22"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.82 26.22 87.33 26.22 87.33 26.21 86.25 25.12 82.62 25.12 85.77 18.94 89.41 26.23 90.65 26.23 85.78 16.49 80.82 26.22"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.3 26.23 140.53 26.23 135.67 16.49 130.71 26.22 137.22 26.22 137.22 26.21 136.13 25.12 132.51 25.12 135.66 18.94 139.3 26.23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.11,21.48c.6-.47,1-1.2,1-2.03,0-1.43-1.16-2.59-2.59-2.59h-5.2l1.1,1.1h4.09c.82,0,1.48.67,1.48,1.48s-.67,1.48-1.48,1.48h-2.1v1.1h2.1c.85,0,1.54.69,1.54,1.54s-.69,1.54-1.54,1.54h-4.02v-5.42h-1.1v6.52h5.13c1.46,0,2.64-1.19,2.64-2.64,0-.86-.42-1.62-1.06-2.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.41,
    y: 19.7,
    width: 1.1,
    height: 6.53
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m73.12,19.45c0-1.43-1.16-2.59-2.59-2.59h-5.19l1.1,1.1h4.09c.82,0,1.48.67,1.48,1.48s-.67,1.48-1.48,1.48h-1.44l2.8,5.3h1.25l-2.23-4.22c1.25-.18,2.21-1.26,2.21-2.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.18,21.46s0,0,0,0l1.09,1.09h1.02c-.43,1.5-1.82,2.58-3.43,2.58-1.97,0-3.58-1.6-3.58-3.58s1.6-3.58,3.58-3.58c1.13,0,2.21.55,2.88,1.46l.89-.65c-.88-1.2-2.29-1.91-3.77-1.91-2.58,0-4.68,2.1-4.68,4.68s2.1,4.68,4.68,4.68c2.4,0,4.4-1.79,4.65-4.17l.07-.61h-3.4v.02Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.49 17.97 118.59 17.97 118.59 25.12 115.37 25.12 115.37 26.22 122.92 26.22 122.92 25.12 119.7 25.12 119.7 17.97 122.92 17.97 122.92 16.86 115.38 16.86 116.49 17.97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.a3817fa3ff93edbf789ecd000fce3686.svg";
export { ForwardRef as ReactComponent };